<template>
  <b-sidebar
    v-if="user"
    no-header
    visible
    width="258px"
    no-close-on-route-change
  >
    <template #footer>
      <b-row
        v-if="!business"
        class="mb-3"
      >
        <b-col class="text-center">
          <div class="sidebar-nav-links d-inline pointer">
            <span
              class="h9"
            >
              <a
                href="https://relancer.com/blog/optimize-relancer-profile/"
                target="_blank"
                style="vertical-align: super;"
              >
                Optimize Your Profile
              </a>
            </span>
          </div>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col class="text-center">
          <i class="ri-logout-box-r-line ri-xl" />
          <div class="sidebar-nav-links d-inline pointer">
            <span
              class="sidebar-logout h8 pl-1"
              @click="logOut"
            >
              Log out
            </span>
          </div>
        </b-col>
      </b-row>
    </template>
    <b-col no-gutters>
      <!-- Logo  -->
      <b-row class="mt-2">
        <router-link
          v-if="recruiter"
          :to="`/recruiter/${recruiter.id}`"
          class="col sidebar-nav-links"
        >
          <LogoWithTextDark />
        </router-link>
        <router-link
          v-if="business"
          :to="`/business/${business.id}`"
          class="col sidebar-nav-links"
        >
          <LogoWithTextDark />
        </router-link>
        <router-link
          v-if="agency"
          :to="`/agency/${agency.id}`"
          class="col sidebar-nav-links"
        >
          <LogoWithTextDark />
        </router-link>
      </b-row>

      <!-- Profile image and stuff -->
      <b-row class="mt-5 d-flex pl-2">
        <!-- Image -->
        <b-col cols="2">
          <b-img
            v-if="!agency"
            :src="user.profile_picture"
            alt="user-pic"
            class="user-pic"
            width="45"
            height="45"
          />
          <b-img
            v-if="agency"
            :src="'/images/client-profile-img.svg'"
            alt="user-pic"
            class="user-pic"
            width="45"
            height="45"
          />
          <b-img
            v-if="!business && localAvailability === 'Available'"
            src="/images/available.svg"
            alt="availability-status"
            class="availability-status"
            width="18"
            height="18"
          />
          <b-img
            v-if="!business && localAvailability === 'Not available'"
            src="/images/not-available.svg"
            alt="availability-status"
            class="availability-status"
            width="18"
            height="18"
          />
          <b-img
            v-if="!business && localAvailability === 'Available from'"
            src="/images/available-from.svg"
            alt="availability-status"
            class="availability-status"
            width="20"
            height="20"
          />
        </b-col>

        <!-- Business data -->
        <b-col v-if="business">
          <router-link
            :to="`/business/${business.id}`"
            class="sidebar-nav-links"
          >
            <b-row class="mt-1">
              <small class="sidebar-user h8 pl-2">
                <b-col class="pr-1">
                  {{ user.full_name }}
                </b-col>
              </small>
            </b-row>
          </router-link>
          <router-link
            :to="`/business/${business.id}`"
            class="sidebar-nav-links"
          >
            <b-row>
              <b-col class="ml-2">
                <small class="sidebar_user-company h8">
                  {{ business.name }}
                </small>
              </b-col>
            </b-row>
          </router-link>
        </b-col>

        <!-- Recruiter data -->
        <b-col v-if="recruiter">
          <router-link
            :to="`/recruiter/${recruiter.id}`"
            class="sidebar-nav-links"
          >
            <b-row class="mt-1">
              <small class="sidebar-user h8 pl-2">
                <b-col class="pr-1">
                  {{ user.full_name }}
                </b-col>
              </small>
            </b-row>
          </router-link>
          <router-link
            :to="`/recruiter/${recruiter.id}`"
            class="sidebar-nav-links"
          >
            <b-row>
              <b-col>
                <small class="sidebar_user-company h8 pl-2">My Profile</small>
              </b-col>
            </b-row>
          </router-link>
        </b-col>

        <!-- Agency data -->
        <b-col v-if="agency">
          <router-link
            :to="`/agency/${agency.id}`"
            class="sidebar-nav-links"
          >
            <b-row class="mt-1">
              <small class="sidebar-user h8 pl-2">
                <b-col class="pr-1">
                  {{ user.full_name }}
                </b-col>
              </small>
            </b-row>
          </router-link>
          <router-link
            :to="`/agency/${agency.id}`"
            class="sidebar-nav-links"
          >
            <b-row>
              <b-col>
                <small class="sidebar_user-company h8 pl-2">My Profile</small>
              </b-col>
            </b-row>
          </router-link>
        </b-col>
      </b-row>

      <!-- Business profile -->
      <router-link
        v-if="business"
        :to="`/business/${business.id}`"
        class="sidebar-nav-links"
      >
        <b-row
          :class="{active: $route.name === 'BusinessProfile'}"
          class="option-cols mt-4 pt-2 pb-2"
        >
          <b-col>
            <i class="ri-building-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">Company Profile</span>
          </b-col>
        </b-row>
      </router-link>

      <!-- Busines projects -->
      <router-link
        v-if="business"
        :to="`/business/${business.id}/projects`"
        class="sidebar-nav-links"
      >
        <b-row
          :class="{active: $route.name === 'BusinessProjects'}"
          class="option-cols mt-1 pt-2 pb-2"
        >
          <b-col>
            <i class="ri-suitcase-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">Projects</span>
          </b-col>
        </b-row>
      </router-link>

      <!-- Busines recruiter search -->
      <router-link
        v-if="business"
        :to="`/recruiter-search`"
        class="sidebar-nav-links"
      >
        <b-row
          :class="{active: $route.name === 'RecruiterSearch'}"
          class="option-cols mt-1 pt-2 pb-2"
        >
          <b-col>
            <i class="ri-search-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">Recruiter Search</span>
          </b-col>
        </b-row>
      </router-link>

      <!-- Business matches -->
      <router-link
        v-if="business && user.role === 'admin'"
        :to="`/business/${business.id}/matches`"
        class="sidebar-nav-links"
      >
        <b-row
          :class="{active: $route.name === 'BusinessMatches'}"
          class="option-cols mt-1 pt-2 pb-2"
        >
          <b-col>
            <i class="ri-group-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">Recruiter Matches</span>
          </b-col>
        </b-row>
      </router-link>
      <!-- Business Project Proposals -->
      <router-link
        v-if="business"
        :to="`/business/${business.id}/fee-proposals`"
        class="sidebar-nav-links"
      >
        <b-row
          :class="{active: $route.name === 'ProposalsView'}"
          class="option-cols mt-1 pt-2 pb-2"
        >
          <b-col>
            <i class="ri-file-list-3-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">Project Proposals</span>
          </b-col>
        </b-row>
      </router-link>

      <!-- Availability dropdown -->
      <div v-if="!business">
        <b-form-select
          v-model="localAvailability"
          v-b-tooltip.hover.bottom
          :options="availabilityOptions"
          size="sm"
          class="mt-3 ml-2"
          style="width:203px"
          :title="getTooltipTitle(localAvailability)"
        />
      </div>
      <div>
        <b-form-datepicker
          v-if="!business && localAvailability === 'Available from'"
          v-model="availabilityDate"
          class="datepicker"
          locale="en-US"
          size="sm"
          hide-header
          no-flip
          calendar-width="100%"
        />
      </div>

      <!-- Recruiter matches -->
      <router-link
        v-if="recruiter"
        :to="`/recruiter/${recruiter.id}/matches`"
        class="sidebar-nav-links"
      >
        <b-row
          :class="{active: $route.name === 'RecruiterMatches'}"
          class="option-cols mt-4 pt-2 pb-2"
        >
          <b-col>
            <i class="ri-suitcase-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">Matches</span>
          </b-col>
        </b-row>
      </router-link>

      <!-- Recruiter Project Proposals -->
      <router-link
        v-if="recruiter"
        :to="`/recruiter/${recruiter.id}/fee-proposals`"
        class="sidebar-nav-links"
      >
        <b-row
          :class="{active: $route.name === 'ProposalsView'}"
          class="option-cols mt-1 pt-2 pb-2"
        >
          <b-col>
            <i class="ri-file-list-3-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">Project Proposals</span>
          </b-col>
        </b-row>
      </router-link>

      <!-- Agency matches -->
      <router-link
        v-if="agency"
        :to="`/agency/${agency.id}/matches`"
        class="sidebar-nav-links"
      >
        <b-row
          :class="{active: $route.name === 'AgencyMatches'}"
          class="option-cols mt-4 pt-2 pb-2"
        >
          <b-col>
            <i class="ri-suitcase-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">Matches</span>
          </b-col>
        </b-row>
      </router-link>

      <!-- Agency Project Proposals -->
      <router-link
        v-if="agency"
        :to="`/agency/${agency.id}/fee-proposals`"
        class="sidebar-nav-links"
      >
        <b-row
          :class="{active: $route.name === 'ProposalsView'}"
          class="option-cols mt-1 pt-2 pb-2"
        >
          <b-col>
            <i class="ri-file-list-3-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">Project Proposals</span>
          </b-col>
        </b-row>
      </router-link>

      <!-- Admin stuff -->
      <b-row
        v-if="user.role === 'admin'"
        class="admin-cols"
      >
        <b-col>
          ADMIN links
        </b-col>
      </b-row>
      <router-link
        v-if="user.role === 'admin'"
        :to="`/admin/user/create`"
        class="sidebar-nav-links"
      >
        <b-row
          class="option-cols"
        >
          <b-col>
            <i class="ri-psychotherapy-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">Create User</span>
          </b-col>
        </b-row>
      </router-link>
      <router-link
        v-if="user.role === 'admin'"
        :to="`/admin/business/create`"
        class="sidebar-nav-links"
      >
        <b-row
          class="option-cols"
        >
          <b-col>
            <i class="ri-amazon-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">Create Client</span>
          </b-col>
        </b-row>
      </router-link>
      <router-link
        v-if="user.role === 'admin'"
        :to="`/admin/project/create`"
        class="sidebar-nav-links"
      >
        <b-row
          class="option-cols"
        >
          <b-col>
            <i class="ri-surgical-mask-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">Create Project</span>
          </b-col>
        </b-row>
      </router-link>
      <router-link
        v-if="user.role === 'admin'"
        :to="`/admin/business`"
        class="sidebar-nav-links"
      >
        <b-row
          class="option-cols"
        >
          <b-col>
            <i class="ri-list-settings-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">All Clients</span>
          </b-col>
        </b-row>
      </router-link>
      <router-link
        :to="`/admin/recruiter`"
        class="sidebar-nav-links"
      >
        <b-row
          v-if="user.role === 'admin'"
          class="option-cols"
        >
          <b-col>
            <i class="ri-account-box-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">All Recruiters</span>
          </b-col>
        </b-row>
      </router-link>
      <router-link
        :to="`/admin/agency`"
        class="sidebar-nav-links"
      >
        <b-row
          v-if="user.role === 'admin'"
          class="option-cols"
        >
          <b-col>
            <i class="ri-hand-coin-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">All agencies</span>
          </b-col>
        </b-row>
      </router-link>
      <router-link
        v-if="user.role === 'admin'"
        :to="`/admin/user`"
        class="sidebar-nav-links"
      >
        <b-row
          class="option-cols"
        >
          <b-col>
            <i class="ri-open-arm-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">All Users</span>
          </b-col>
        </b-row>
      </router-link>
      <router-link
        v-if="user.role === 'admin'"
        :to="`/admin/projects`"
        class="sidebar-nav-links"
      >
        <b-row
          class="option-cols"
        >
          <b-col>
            <i class="ri-aliens-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">All Projects</span>
          </b-col>
        </b-row>
      </router-link>
      <router-link
        v-if="user.role === 'admin'"
        :to="`/admin/job-titles`"
        class="sidebar-nav-links"
      >
        <b-row
          class="option-cols"
        >
          <b-col>
            <i class="ri-price-tag-3-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">Job Titles</span>
          </b-col>
        </b-row>
      </router-link>
      <router-link
        v-if="user.role === 'admin'"
        :to="`/admin/cities`"
        class="sidebar-nav-links"
      >
        <b-row
          class="option-cols"
        >
          <b-col>
            <i class="ri-map-pin-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">Cities</span>
          </b-col>
        </b-row>
      </router-link>
      <router-link
        v-if="user.role === 'admin'"
        :to="`/admin/ai-reviews`"
        class="sidebar-nav-links"
      >
        <b-row
          class="option-cols"
        >
          <b-col>
            <i class="ri-robot-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">Profile Reviews</span>
          </b-col>
        </b-row>
      </router-link>
      <router-link
        v-if="user.role === 'admin'"
        :to="`/admin/message-reviews`"
        class="sidebar-nav-links"
      >
        <b-row
          class="option-cols"
        >
          <b-col>
            <i class="ri-mail-check-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">Message Reviews</span>
          </b-col>
        </b-row>
      </router-link>
      <!-- Temp disabled, since too big server load  -->
      <!-- <router-link
        v-if="user.role === 'admin'"
        :to="`/admin/matches`"
        class="sidebar-nav-links"
      >
        <b-row
          class="option-cols"
        >
          <b-col>
            <i class="ri-command-line ri-xl" />
            <span class="sidebar-menu-headings h8 pl-2">All Matches</span>
          </b-col>
        </b-row>
      </router-link> -->
      <div
        v-if="user.role === 'admin'"
        class="mt-3 mb-2 px-3"
      >
        <b-btn
          :variant="regenerateState === 'success' ? 'success' : regenerateState === 'error' ? 'danger' : 'secondary'"
          :disabled="regenerateState === 'running'"
          size="sm"
          block
          @click="confirmRegenerate"
        >
          <b-spinner
            v-if="regenerateState === 'running'"
            small
            class="mr-1"
          />
          {{ regenerateLabel }}
        </b-btn>
      </div>

      <b-modal
        id="regenerate-confirm"
        title="Regenerate All Pages"
        ok-title="Yes, regenerate"
        cancel-title="Cancel"
        ok-variant="primary"
        hide-header-close
        header-class="justify-content-center pb-3"
        body-class="text-center py-3"
        footer-class="justify-content-center border-top-0 pt-0"
        @ok="runRegenerate"
      >
        Are you sure? This rebuilds all listing pages and takes 1–2 minutes. The button will show "Done" when finished.
      </b-modal>
    </b-col>
  </b-sidebar>
</template>

<script>
import axios from '@/helpers/cleanAxios'
import LogoWithTextDark from '@/components/svgs/LogoWithTextDark'
import FeeCalculator from '@/components/FeeCalculator'
import { useAuthStore } from '@/stores/auth'
import { mapState, mapWritableState } from 'pinia'

export default {
  name: 'Sidebar',
  components: {
    LogoWithTextDark,
    FeeCalculator,
  },
  data () {
    return {
      businessOptions: [],
      availabilityOptions: [
        { value: 'Available', text: '✅Available' },
        { value: 'Not available', text: '🛑Not available' },
        { value: 'Available from', text: '⏸️Available from' },
      ],
      availabilityDate: '',
      regenerateState: 'idle',
      regenerateMessage: '',
      _resetTimer: null,
    }
  },
  computed: {
    ...mapState(useAuthStore, [
      'user',
      'recruiter',
      'agency',
    ]),
    ...mapWritableState(useAuthStore, [
      'business',
    ]),
    ...mapState(useAuthStore, {
      allBusinesses: (state) => (state.user || {}).businesses,
    }),
    selectedBusiness: {
      get: function () {
        if (!this.business) {
          return null
        }
        return this.business.id
      },
      set: function (value) {
        if (!this.business) {
          return
        }
        // Only update if value differs
        if (value !== this.business.id) {
          const foundBusiness = this.allBusinesses.find(business => {
            if (business.id === value) {
              return true
            }
            return false
          })
          this.business = foundBusiness
          this.$router.push(`/business/${value}/projects`)
        }
      },
    },
    showRepresenting () {
      if (this.user.role === 'admin') {
        return true
      }
      if (this.user.businesses && this.user.businesses.length > 1) {
        return true
      }
      return false
    },
    localAvailability: {
      get () {
        const availability = this.recruiter?.availability || this.agency?.availability
        if (availability === 'Available') {
          return 'Available'
        } else if (availability === 'Not available') {
          return 'Not available'
        } else {
          return 'Available from'
        }
      },
      set (newVal) {
        if (this.recruiter) {
          if (newVal === 'Available' && this.recruiter.availability !== 'Available') {
            this.recruiter.availability = 'Available'
            axios.patch(`/v3/recruiters/${this.recruiter.id}`, {
              availability: this.recruiter.availability,
            })
          } else if (newVal === 'Not available' && this.recruiter.availability !== 'Not available') {
            this.recruiter.availability = 'Not available'
            axios.patch(`/v3/recruiters/${this.recruiter.id}`, {
              availability: this.recruiter.availability,
            })
          } else {
            this.recruiter.availability = this.availabilityDate
            if (this.availabilityDate) {
              axios.patch(`/v3/recruiters/${this.recruiter.id}`, {
                availability: this.recruiter.availability,
              })
            }
          }
        } else if (this.agency) {
          if (newVal === 'Available' && this.agency.availability !== 'Available') {
            this.agency.availability = 'Available'
            axios.patch(`/v3/agencies/${this.agency.id}`, {
              availability: this.agency.availability,
            })
          } else if (newVal === 'Not available' && this.agency.availability !== 'Not available') {
            this.agency.availability = 'Not available'
            axios.patch(`/v3/agencies/${this.agency.id}`, {
              availability: this.agency.availability,
            })
          } else {
            this.agency.availability = this.availabilityDate
            if (this.availabilityDate) {
              axios.patch(`/v3/agencies/${this.agency.id}`, {
                availability: this.agency.availability,
              })
            }
          }
        }
      },
    },
    regenerateLabel () {
      if (this.regenerateState === 'running') return 'Regenerating...'
      if (this.regenerateState === 'success') return this.regenerateMessage || 'Done'
      if (this.regenerateState === 'error') return 'Failed — try again'
      return 'Regenerate Pages'
    },
  },
  watch: {
    availabilityDate (newVal) {
      if (this.recruiter && (newVal !== this.recruiter.availability)) {
        this.recruiter.availability = this.availabilityDate
        axios.patch(`/v3/recruiters/${this.recruiter.id}`, {
          availability: this.recruiter.availability,
        })
      } else if (this.agency && (newVal !== this.recruiter.availability)) {
        this.agency.availability = this.availabilityDate
        axios.patch(`/v3/agencies/${this.agency.id}`, {
          availability: this.agency.availability,
        })
      }
    },
  },
  beforeDestroy () {
    clearTimeout(this._resetTimer)
  },
  mounted () {
    if (this.localAvailability === 'Available from') {
      this.availabilityDate = this.recruiter?.availability || this.agency?.availability
    }

    setTimeout(() => {
      if (window.sessionStorage.openCalculator) {
        this.$bvModal.show('FeeCalculator')
        window.sessionStorage.removeItem('openCalculator')
      }
    }, 50)

    if (this.user.role === 'admin') {
      useAuthStore().self()
        .then(() => {
          this.businessOptions = this.allBusinesses.map(business => {
            return {
              value: business.id,
              text: (business.name || '').trim() || '-null',
            }
          }).sort((a, b) => a.text.localeCompare(b.text))
        })
        .catch((error) => {
          this.$bvToast.toast('Error fetching list of clients', {
            title: 'Error',
            variant: 'danger',
            autoHideDelay: 3000,
            solid: true,
          })
          throw error
        })
    }
    if (this.user.businesses.length > 1) {
      this.businessOptions = this.allBusinesses.map((business) => {
        return {
          value: business.id,
          text: business.name,
        }
      })
    }
  },
  methods: {
    logOut () {
      axios.post('/v2/logout').then(() => {
        window.localStorage.clear()
        window.sessionStorage.clear()
        window.location.href = '/'
      })
        .catch((error) => {
          this.$bvToast.toast('Error when trying to log out', {
            title: 'Error',
            variant: 'danger',
            autoHideDelay: 3000,
            solid: true,
          })
          throw error
        })
    },
    getTooltipTitle (selectedOption) {
    // Define the tooltip titles based on the selectedOption value
      if (selectedOption === 'Available') {
        return 'When you’re available, you will receive project opportunities via email.'
      } else if (selectedOption === 'Not available') {
        return 'When you’re not available, you will not receive project opportunities.'
      } else if (selectedOption === 'Available from') {
        return 'You can set the date when you will be available for recruitment projects. Meanwhile, you will not receive project opportunities.'
      } else {
        return '' // Return an empty string if there's no tooltip for the selectedOption
      }
    },
    confirmRegenerate () {
      this.$bvModal.show('regenerate-confirm')
    },
    async runRegenerate () {
      this.regenerateState = 'running'
      try {
        const { data } = await axios.post('/admin/v3/pages/regenerate')
        this.regenerateMessage = data.message
        this.regenerateState = 'success'
      } catch (e) {
        this.regenerateState = 'error'
      } finally {
        this._resetTimer = setTimeout(() => {
          this.regenerateState = 'idle'
        }, 5000)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.admin-cols {
  border-top: 2px solid red;
}
.sidebar-user {
  font-size: 16px;
  color: #39364f;
}
.user-pic {
  object-fit: cover;
  border-radius: 200px;
}
.sidebar_user-company {
  font-weight: 400;
  vertical-align: top;
  color: #39364f;
}
.sidebar-menu-headings {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  vertical-align: top;
}
.sidebar-logout {
  vertical-align: text-top;
}
.sidebar-nav-links {
  text-decoration: none;
  color: inherit;
  .small-btn {
    border: none !important;
    background: none !important;
    color: #ee8b7b;
    -webkit-box-shadow: none;
    box-shadow: none !important;
    &:hover,
    &:active,
    &.active {
      background: none !important;
      box-shadow: none !important;
      color: #ee8b7b;
    }
}
}
.option-cols {
  padding-left: 15px;

  &:hover,
  &:active,
  &.active {
    background-color: rgba(255, 255, 255, 0.4);
    border-left: 10px solid #ee8b7b;
    padding-left: 5px;
    border-radius: 3px;
  }
}
.badge {
  border-radius: 0;
  font-size: 12px;
  line-height: 1;
  padding: 0.375rem 0.5625rem;
  font-weight: normal;
  background-color: #323031;
  color: #fff;
  border-radius: 10rem;
}
a.badge-secondary:hover {
  background-color: #323031;
  color: #fff;
}
.availability-status {
  position: absolute;
  top: 32px;
  left: 45px;
}
.b-form-btn-label-control.form-control {
  width: 203px;
  margin: auto;
  margin-top: 4px;
  margin-left: 8px;
  font-size: 12px;
}
</style>
